export default __webpack_public_path__ + "static/media/ThingsThatSting_06.46d1c056.png";